var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-list"},_vm._l((_vm.specials),function(special){return _c('Special',{key:special.id,attrs:{"special-id":special.id,"image-url":special.imageUrl}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }